export const HTTP_STATUS = {
  badRequest: 400,
  notAcceptable: 406,
  conflict: 409,
  locked: 423,
} as const;
